<template>
  <div
    v-if="isShowing && selectedAd != null"
    :style="componentStyle"
  >
    <component :is="selectedAd.component" />
  </div>
</template>

<script>
  import { defineAsyncComponent } from 'vue'

  export default {
    name: 'FontAwesomeAd',

    components: {
      ProNarrow: defineAsyncComponent(() => import('./Pro/Narrow')),
      ProWide: defineAsyncComponent(() => import('./Pro/Wide')),
      ProIconsNarrow: defineAsyncComponent(() => import('./ProIcons/Narrow')),
      ProIconsWide: defineAsyncComponent(() => import('./ProIcons/Wide'))
    },

    props: {
      context: {
        type: Array,
        default: () => ['docs', 'download', 'icons', 'search', 'versions']
      },

      customStyle: {
        type: Object,
        default: () => {}
      },

      layout: {
        type: String,
        default: 'wide'
      }
    },

    data() {
      return {
        isShowing: false,

        ads: [
          { component: 'ProNarrow', layout: 'narrow', context: ['docs', 'download', 'icons', 'search', 'versions'] },
          { component: 'ProWide', layout: 'wide', context: ['docs', 'download', 'icons', 'search', 'versions'] },
          { component: 'ProIconsNarrow', layout: 'narrow', context: ['icons', 'search'] },
          { component: 'ProIconsWide', layout: 'wide', context: ['icons', 'search'] }
        ],

        selectedAd: null
      }
    },

    computed: {
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    },

    created() {
      this.selectedAd = this.loadRandomAd()
    },

    mounted() {
      this.isShowing = this.$marketing.showAdvertising
    },

    methods: {
      loadRandomAd() {
        const ads = this.getAdsList()

        if (ads.length == 0) {
          console.error('FA Ad: context or layout do not match defined values')
          return null
        } else {
          const adNumber = Math.floor(Math.random() * ads.length)
          return ads[adNumber]
        }
      },

      getAdsList() {
        return this.ads.filter((ad) => {
          const contextMatch = ad.context.reduce((acc, c) => {
            return acc || this.context.includes(c)
          }, false)
          return ad.layout == this.layout && contextMatch
        })
      }
    }
  }
</script>
